import _ from 'lodash';
//import async from 'async';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { withStyles } from '@material-ui/core/styles';

import SplitBillPageContainer from '../../containers/billing/SplitBillPage';
import ResourceUploader from '../form/ResourceUploader';
import Button from '@material-ui/core/Button';
import FMPText from '../pureForm/FMPText';
import Zoom from '@material-ui/core/Zoom';
import CircularProgress from '@material-ui/core/CircularProgress';
import GreenChecked from '../../images/icons/greenChecked.svg';
import Transition from './Transition';

const styles = (theme) => ({
	paper: {
		width: '100%',
		overflowX: 'auto',
	},
	dialogPadding: {
		padding: 10,
		[theme.breakpoints.up('md')]: {
			padding: '20px 50px 50px 50px',
		},
	},
	dialogPaper: {
		overflow: 'scroll',
		maxWidth: '100%',
		width: 800,
		//maxWidth: '98%',
		maxHeight: 'calc(100% - 20px)',
		margin: 10,
	},
	greenCheckedIcon: {
		display: 'inline-block',
		width: 33,
		height: 33,
		backgroundImage: `url('${GreenChecked}')`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
		marginLeft: 5,
	},
	isSaving: {
		marginLeft: 20,
		fontSize: 16,
		color: '#1565C0',
	},
	savingSuccessful: {
		marginLeft: 20,
		fontSize: 16,
		color: '#2E7D32',
	},
});

class MultiPageBillDialog extends Component {
	constructor(props) {
		super(props);
		this.state = {
			formFieldError: {},
			isSaving: false,
			savingSuccessful: false,
			closingIn: 4,
		};
	}

	handleDataFileUpload = ({ resource }) => {
		this.setState({ multiPageResourceId: resource.resourceId });
	};

	handleSave = () => {
		const { splitMultiPageBill, showErrors } = this.props;

		const { billName, multiPageResourceId } = this.state;

		//- Required fields
		const formFieldError = {};
		const errors = [];

		const _setError = (path, error) => {
			_.set(formFieldError, path, error);
			errors.push(error);
		};

		let fields = [
			{ fieldName: 'billName', display: 'Bill Name' },
			{ fieldName: 'multiPageResourceId', display: 'Upload File' },
		];

		fields.forEach((s) => {
			if (!this.state[s.fieldName]) {
				_setError([s.fieldName], `${s.display} is required`);
			}
		});

		if (!_.isEmpty(errors)) {
			this.setState({ formFieldError });
			return showErrors(errors);
		}

		this.setState({ isSaving: true, savingSuccessful: false });

		splitMultiPageBill({
			params: {
				billName,
				multiPageResourceId,
			},
			callback: (err) => {
				if (err) {
					this.setState({ isSaving: false });
					showErrors(err);
					return;
				}

				_.delay(() => {
					this.setState({
						isSaving: false,
						savingSuccessful: true,
					});

					_.delay(() => {
						this.setState({ closingIn: 3 });
					}, 0);
					_.delay(() => {
						this.setState({ closingIn: 2 });
					}, 1000);
					_.delay(() => {
						this.setState({ closingIn: 1 });
					}, 2000);
					_.delay(() => {
						this.setState({ closingIn: 0 });
					}, 3000);
				}, 400);
			},
		});
	};

	// eslint-disable-next-line no-unused-vars
	componentDidUpdate(prevProps, prevState, snapshot) {
		if (this.state.closingIn === 0 && prevState.closingIn === 1) {
			this.handleClose();
		}
	}

	onChange = (value, path) => {
		const arrayPath = _.isString(path) ? _.toPath(path) : path;

		const val = _.isObject(value) && value.target ? value.target.value : value;

		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			base = _.cloneDeep(base);
			_.set(base, arrayPath.slice(1), val);
			newState[basePath] = base;
		} else {
			newState[basePath] = val;
		}

		this.setState(newState);
	};

	getInputProps = (path) => {
		return {
			path,
			value: this.getValue(path),
			error: this.getError(path),
			onChange: this.onChange,
			checked: this.getValue(path, false),
			md: 12,
		};
	};

	getValue = (path, defaultValue) => {
		const _d = _.isUndefined(defaultValue) ? '' : defaultValue;
		return _.get(this.state, path, _d);
	};
	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	handleClose = () => {
		this.props.onClose();
	};

	render() {
		const { classes, fullScreen, open } = this.props;

		const { isSaving, savingSuccessful, closingIn } = this.state;

		return (
			<Dialog
				fullScreen={fullScreen}
				maxWidth="md"
				open={open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				classes={{ paper: classes.dialogPaper }}
			>
				<div className={classes.dialogPadding}>
					<DialogTitle style={{ paddingBottom: 5 }}>Split a multi page PDF bill</DialogTitle>
					<DialogContent>
						<FMPText {...this.getInputProps('billName')} label="Bill Name / Description" />

						<ResourceUploader
							name={'dataFileResourceId'}
							label={''}
							afterUpload={this.handleDataFileUpload}
							onlyOne={true}
							stayOnSuccessAfterUpload={true}
						/>
					</DialogContent>

					<div style={{ display: 'flex', alignItems: 'baseline' }}>
						<Button
							variant="contained"
							color={'primary'}
							style={{ borderRadius: '100px' }}
							onClick={this.handleSave}
							disabled={isSaving}
						>
							Split Multi Page Bill
						</Button>

						<Button onClick={this.handleClose}>Close</Button>

						<Zoom
							in={isSaving}
							style={{ transitionDelay: isSaving ? '0ms' : '0ms' }}
							mountOnEnter
							unmountOnExit
						>
							<div className={classes.isSaving}>
								<CircularProgress style={{ verticalAlign: 'middle' }} />
								<span style={{ paddingLeft: 10 }}>Saving...</span>
							</div>
						</Zoom>

						<Zoom
							in={savingSuccessful}
							style={{ transitionDelay: savingSuccessful ? '250ms' : '0ms' }}
						>
							<div className={classes.savingSuccessful}>
								<div className={classes.greenCheckedIcon} />
								<span style={{ paddingLeft: 10 }}>Save Successful. Closing in {closingIn}.</span>
							</div>
						</Zoom>
					</div>
				</div>
			</Dialog>
		);
	}
}

MultiPageBillDialog.propTypes = {
	splitMultiPageBill: PropTypes.func.isRequired,
	classes: PropTypes.object.isRequired,
	open: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
	fullScreen: PropTypes.bool.isRequired,
	showErrors: PropTypes.func,
	history: PropTypes.object.isRequired,
};

export default _.flow([withStyles(styles), withMobileDialog(), SplitBillPageContainer])(
	MultiPageBillDialog
);
